<template>
  <div class="row" v-on:mousemove="checkInactivityMoveMouse">
    <div
      class="col d-flex justify-content-between align-items-center"
      v-if="loading == false"
    >
      <div class="col-md-auto px-0">
      <botao-remanejar class="mb-3" servico="acolhimento-idoso" :registro="acolhimento" @remanejado="$router.go(-1)" />
        <h1 class="h3 mb-3 text-gray-800">
          Acolhimento: #{{ $route.params.id }}
        </h1>
      </div>
      <div class="col-md-auto">
        <nav aria-label="breadcrumb" v-if="acolhimento">
          <ol class="breadcrumb" style="display: flex">
            <li class="breadcrumb-item active" aria-current="page">
              <router-link
                :to="`/dashboard/acolhimentos/idoso/${acolhimento.unidade_id}`"
              >
                Acolhimentos
              </router-link>
            </li>
            <li class="breadcrumb-item active" aria-current="page">
              Acolhimento #{{ $route.params.id }}
            </li>
          </ol>
        </nav>
      </div>
    </div>
    <load v-if="loading" message="Carregando o acolhimento" />
    <div v-else class="col-md-12">
      <div class="row">
        <div class="col-md-12">
          <Header :item="acolhimento" />
        </div>
      </div>
      <!--Tabela-->
      <div class="row">
        <SidebarServico @page="showPage" :acolhimento="acolhimento"/>
        <ModalVerificarPrivado
          :familia-id="acolhimento.familia_id"
          v-if="acolhimento.privado == 1 && status_privado == false"
          @liberar="status_privado = true"
        />
        <div
          v-else
          class="col-md-9"
          v-on:mousemove="status_privado = !checkInactivity"
        >
          <div v-if="page == 'home'">
            <div v-if="historicoStatus == false" class="card mb-0 shadow">
              <div class="card-body">
                <div class="tab-content">
                  <div class="animate__animated animate__fadeIn">
                    <div class="col-12 px-0">
                      <h4 class="font-weight-bold">Editar Acolhimento</h4>
                    </div>
                    <HeaderAcolhimento
                      class="px-0"
                      :item="acolhimento"
                      tipo="idoso"
                    />
                    <b-tabs content-class="mt-3">
                      <b-tab title="Detalhes" active>
                        <Detalhe
                          :item="acolhimento"
                          @submit="submit"
                          @reload="getAcolhimento"
                        />
                      </b-tab>
                      <b-tab title="Documentação/Identificação Processual">
                        <Documentacao
                          @reload="getAcolhimento"
                          :item="acolhimento"
                          @submit="submit"
                        />
                      </b-tab>
                      <b-tab title="Tipo de vínculo">
                        <Dinamica
                          @reload="getAcolhimento"
                          :item="acolhimento"
                          @submit="submit"
                        />
                      </b-tab>
                    </b-tabs>
                  </div>
                </div>
              </div>
            </div>
            <div class="card mb-0 shadow card-body" v-else>
              <div class="tab-content">
                <div class="animate__animated animate__fadeIn">
                  <div class="row">
                    <div class="col-12">
                      <h4 class="font-weight-bold">Editar Acolhimento</h4>
                    </div>
                    <!-- <HistoricoStatus
											@voltar="historicoStatus = false"
											:id="acolhimento.id"
											:familia="acolhimento.familia_id"
											:status="status_acolhimento"
										/> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
          <PrimeiraObservacao
            :item="acolhimento"
            v-if="page == 'primeira'"
            @submit="submit"
          />
          <Caracteristica
            :item="acolhimento"
            v-if="page == 'caracteristica'"
            @submit="submit"
          />
          <ObjetivoIdoso
            :item="acolhimento"
            v-if="page == 'objetivo_idoso'"
            @reload="getAcolhimento"
            @submit="submit"
          />
          <Atividade
            :item="acolhimento"
            v-if="page == 'atividade'"
            @submit="submit"
            @reload="submit"
          />
          <Encaminhamentos
            :item="acolhimento"
            v-if="page == 'encaminhamentos'"
            @submit="submit"
            @reload="submit"
          />
          <Fortalecimento
            :item="acolhimento"
            v-if="page == 'fortalecimento'"
            @submit="submit"
            @reload="submit"
          />
          <Pia :item="acolhimento" v-if="page == 'pia'" />
          <Paf :item="acolhimento" v-if="page == 'paf'" />
          <Termo :item="acolhimento" v-if="page == 'termo'" />
          <Auditoria :id="acolhimento.id"  v-if="page == 'historicopia'"/>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SidebarServico from "../includes/SidebarServicoIdoso";
import Header from "../includes/Header";
import HeaderAcolhimento from "../includes/HeaderAcolhimento";
import HistoricoStatus from "../HistoricoStatus";
import PrimeiraObservacao from "../includes/abasIdoso/PrimeiraObservacao";
import Caracteristica from "../includes/abasIdoso/Caracteristica";
import ObjetivoIdoso from "../includes/abasIdoso/ObjetivoIdoso";
import Pia from "../includes/abasIdoso/PIA.vue";
import Paf from "../includes/abasIdoso/PAF.vue";
import Auditoria from "../includes/abasIdoso/Auditoria.vue";
import Documentacao from "../includes/abasIdoso/Documentacao";
import Dinamica from "../includes/abasIdoso/Dinamica";
import Detalhe from "../includes/abasIdoso/Detalhe";
import Atividade from "../includes/abasIdoso/AcolhimentoAtividades";
import Encaminhamentos from "../includes/abasIdoso/Encaminhamento";
import Fortalecimento from "../includes/abasIdoso/Fortalecimento";
import ModalVerificarPrivado from "../includes/ModalVerificarPrivado";
import Termo from "../includes/abasIdoso/Termo";

export default {
  components: {
    SidebarServico,
    Header,
    HeaderAcolhimento,
    HistoricoStatus,
    PrimeiraObservacao,
    Caracteristica,
    ObjetivoIdoso,
    Pia,
    Paf,
    Dinamica,
    Detalhe,
    Atividade,
    Encaminhamentos,
    Fortalecimento,
    Documentacao,
    ModalVerificarPrivado,
    Termo,
    Auditoria
  },
  name: "Edit",
  data() {
    return {
      page: "home",
      acolhimento: {
        motivo: [],
      },
      familia: {},
      files: {},
      status_privado: false,
      loading: true,
      progressCompleted: 0,
      historicoStatus: false,
      model: "Acolhimento",
    };
  },
  mounted() {
    this.getAcolhimento();
    this.$bvModal.show("verificar-acolhimento-privado");
  },
  computed: {
    checkInactivity() {
      if (this.$root.isIdle == true) {
        this.status_privado = false;
        this.$bvModal.show("verificar-acolhimento-privado");
      }
      return this.$root.isIdle;
    },
  },
  methods: {
    checkInactivityMoveMouse() {
      if (this.acolhimento.privado == 1) {
        if (this.$root.isIdle == true) {
          this.status_privado = false;
          this.$bvModal.show("verificar-acolhimento-privado");
        }
        return this.$root.isIdle;
      } else {
        return false;
      }
    },
    showPage(page) {
      this.page = page;
    },

    getAcolhimento() {
      let id = this.$route.params.id;
      axios
        .get(`api/dashboard/acolhimento/idoso/${id}`)
        .then((response) => {
          this.acolhimento = response.data.data;
        })
        .finally(() => {
          this.loading = false;
        })
        .catch((error) => {
          this.$router.push("/dashboard/acolhimento/unidades");
        });
    },

    submit() {
      if (this.acolhimento.data_ingresso) {
        this.acolhimento.data_ingresso = moment(
          this.acolhimento.data_ingresso,
          "YYYY-MM-DD"
        ).format("YYYY-MM-DD");
      }
      
      if (this.acolhimento.tecnicos) {
        this.acolhimento.tecnicos = this.acolhimento.tecnicos
          .map((item) => {
            if (item && typeof item === "object") {
              return item.id;
            }

            return item;
          })
          .filter((item) => {
            return item !== null &&
              item !== undefined &&
              item !== "" &&
              !isNaN(Number(item));
          })
          .map((item) => Number(item));
      }

      let ladda = Ladda.create(document.querySelector(".btn-submit"));
      ladda.start();

      axios
        .post(`api/dashboard/acolhimento/idoso/update`, this.acolhimento, {
          header: { "Content-Type": "multipart/form-data" },
          onUploadProgress: (event) => {
            let progress = Math.round((event.loaded * 100) / event.total);
            this.progressCompleted = progress;
          },
        })
        .then((response) => {
          this.acolhimento = response.data.data;
          ladda.stop();
          this.$snack.success({
            button: false,
            text: "Dados salvos com sucesso.",
          });
          //window.location.reload();
          this.$emit("voltar");
          this.$emit("reload");
        })
        .finally(() => {
          this.progressCompleted = 0;
          this.files = [];
        });
    },
  },
};
</script>
<style>
.router-link-exact-active {
  cursor: pointer;
}
</style>
